export default function Marquee({ items = [], className = "" }) {
  const doubled = [...items, ...items];
  return (
    <div className={`relative overflow-hidden ${className}`} data-testid="marquee">
      <div className="marquee-track flex w-max whitespace-nowrap">
        {doubled.map((it, i) => (
          <span key={i} className="flex items-center gap-4 px-4 text-sm font-medium text-muted-foreground md:gap-7 md:px-7 md:text-base">
            {it}
            <span className="w-1.5 h-1.5 rounded-full bg-primary/40" />
          </span>
        ))}
      </div>
    </div>
  );
}
